import { render, staticRenderFns } from "./v80c1010.vue?vue&type=template&id=3d1b880e&"
import script from "./v80c1010.vue?vue&type=script&lang=js&"
export * from "./v80c1010.vue?vue&type=script&lang=js&"
import style0 from "./v80c1010.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports